export default __webpack_public_path__ + "static/media/image.0e715bde.jpeg";